import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import {
  RestCustomInspectionContentItemModel,
  RestCustomInspectionModel,
} from '@main-application/boards/interfaces/custom-inspection';
import { CustomInspectionService } from '@main-application/boards/services/custom-inpection.service';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';
import { InputComponent } from '@ui-components/components/input/input.component';

export interface CustomInspectionSaveTemplateDialogData {
  inspectionTemplate: RestCustomInspectionModel;
  inspectionTemplateContent: RestCustomInspectionContentItemModel[];
  showDoNotShowAgain?: boolean;
}

export interface CustomInspectionSaveTemplateDialogResult {
  doNotShowAgain?: boolean;
}

@Component({
  selector: 'app-schedule-save-template-dialog',
  templateUrl: './custom-inspection-save-template-dialog.component.html',
  styleUrls: ['./custom-inspection-save-template-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CustomInspectionSaveTemplateDialogComponent implements AfterViewInit {
  form = this.formBuilder.group({
    name: [this.data?.inspectionTemplate.inspectionName, [Validators.required]],
  });

  @ViewChild(InputComponent) templateInput: InputComponent;

  doNotShowAgain = false;

  constructor(
    public dialogRef: MatDialogRef<
      CustomInspectionSaveTemplateDialogComponent,
      CustomInspectionSaveTemplateDialogResult
    >,
    protected store: Store<{}>,
    protected cdr: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private customInspectionService: CustomInspectionService,
    private snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) protected data: CustomInspectionSaveTemplateDialogData
  ) {}

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.templateInput?.inputControl.nativeElement.focus();
    }, 0);
  }

  cancel() {
    this.dialogRef.close({ doNotShowAgain: this.doNotShowAgain });
  }

  save() {
    if (this.form.valid) {
      const saveObservable =
        this.form.value.name === this.data.inspectionTemplate.inspectionName
          ? this.customInspectionService.updateCustomInspectionTemplateContent(
              this.data.inspectionTemplate.id,
              this.data.inspectionTemplateContent
            )
          : this.customInspectionService.addCustomInspectionTemplateWithItems(
              {
                inspectionName: this.form.value.name,
                isRequired: this.data.inspectionTemplate.isRequired,
              },
              this.data.inspectionTemplateContent
            );
      (
        saveObservable as Observable<
          [number, RestCustomInspectionContentItemModel[]] | RestCustomInspectionContentItemModel[]
        >
      ).subscribe(() => {
        this.snackbarService.success(`${this.form.value.name} saved`);
      });
      this.cancel();
    } else {
      this.form.markAllAsTouched();
    }
  }
}
